<template>
  <button
    :disabled="disabled"
    type="button"
    class="outline-none text-sm px-2 py-2 transition-colors duration-300 flex items-center gap-2 h-full"
    @click="setSelectedSort">
    <div>
      <slot></slot>
    </div>
    <div>
      <svg
        v-if="this.selectedSort.name === this.name && !this.selectedSort.descending"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 15l7-7 7 7"
        />
      </svg>
      <svg
        v-if="this.selectedSort.name !== this.name"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M18 12H6"
        />
      </svg>
      <svg
        v-if="this.selectedSort.name === this.name && this.selectedSort.descending"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    name: String,
    selectedSort: Object,
    disabled: Boolean,
  },
  methods: {
    setSelectedSort() {
      if (this.selectedSort.name === this.name) {
        if (this.selectedSort.descending) {
          this.$emit('setSelectedSort', {
            ...this.selectedSort,
            name: '',
          })
        } else {
          this.$emit('setSelectedSort', {
            ...this.selectedSort,
            descending: true,
          })
        }
      } else {
        this.$emit('setSelectedSort', {
          name: this.name,
          descending: false,
        })
      }
    },
  },
}
</script>

<style></style>
